import React from 'react';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';
import '../styles/ThankYouPopup.css';

interface ThankYouPopupProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const ThankYouPopup: React.FC<ThankYouPopupProps> = ({ 
  isOpen, 
  onClose,
  message = "Thank you for your response!"
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="popup-icon">
          <FaCheckCircle />
        </div>
        <h2>Thank You!</h2>
        <p>{message}</p>
        <button className="confirm-button" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default ThankYouPopup;